// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3930) return "static/chunks/164f4fb6-efba0f2af3364e75.js";
	if (chunkId === 5033) return "static/chunks/2f0b94e8-b467919bda3b2249.js";
	if (chunkId === 1536) return "static/chunks/1536-e4635d6212d6188b.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"501":"bc98253f","4316":"ad2866b8"}[chunkId] || chunkId) + "." + {"501":"c295c4445406fa0d","4316":"da7517a88118b074","6241":"4cc382c4b694585f","6457":"5b0288fcfbabb9bf","6735":"a3eb23c166e5ee5a"}[chunkId] + ".js";
};